import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirmation-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.showUpdateDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showUpdateDialog) = $event)),
    style: { width: '450px' },
    header: _ctx.t('pwa.updateTitle'),
    modal: true,
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.t('pwa.update'),
        icon: "pi pi-refresh",
        class: "p-button-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh()))
      }, null, 8, ["label"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.t("pwa.updateDescription")) + ".", 1)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}